import type { MouseEventHandler, Ref } from "react"
import { IconEye, IconHistory, IconPencil, IconTrash } from "@tabler/icons-react"
import { Button } from "@/components/ui/button"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import "./record-action.css"

/** Presentation only. Callers supply permitted actions and their existing handlers. */
export function RecordAction({ label, kind, onClick, ref }: {
  label: string; kind: "view" | "edit" | "history" | "remove"; onClick: MouseEventHandler<HTMLButtonElement>; ref?: Ref<HTMLButtonElement>
}) {
  const Icon = kind === "edit" ? IconPencil : kind === "history" ? IconHistory : kind === "remove" ? IconTrash : IconEye
  return <Tooltip><TooltipTrigger asChild>
    <Button ref={ref} variant="outline" size="icon" className="record-action" data-destructive={kind === "remove" || undefined} aria-label={label} onClick={onClick}><Icon className="size-4" aria-hidden="true" /></Button>
  </TooltipTrigger><TooltipContent sideOffset={5}>{label}</TooltipContent></Tooltip>
}
